import { object, string } from 'yup';

import * as constants from '@/constants';
import i18n from '@/settings/i18n';
import { emailSchema } from './email';

export const contactLength = {
  corporationName: 100,
  departmentName: 100,
  postalCode: 11,
  address: 100,
  phoneNumber: 15,
  addressee: 100,
};

export const contactBaseSchema = object({
  corporationName: string()
    .max(
      contactLength.corporationName,
      i18n.t('ui.error.maxlength', {
        length: contactLength.corporationName,
      }),
    )
    .trim()
    .required(i18n.t('ui.error.required.input')),
  departmentName: string()
    .max(
      contactLength.departmentName,
      i18n.t('ui.error.maxlength', {
        length: contactLength.departmentName,
      }),
    )
    .trim()
    .required(i18n.t('ui.error.required.input')),
  firstName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.maxlength', { length: constants.NAME_LENGTH }),
    )
    .matches(constants.KANA_KANJI_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
  lastName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.maxlength', { length: constants.NAME_LENGTH }),
    )
    .matches(constants.KANA_KANJI_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
  kanaFirstName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.maxlength', { length: constants.NAME_LENGTH }),
    )
    .matches(constants.KANA_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
  kanaLastName: string()
    .max(
      constants.NAME_LENGTH,
      i18n.t('ui.error.maxlength', { length: constants.NAME_LENGTH }),
    )
    .matches(constants.KANA_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
  phoneNumber: string()
    .max(
      contactLength.phoneNumber,
      i18n.t('ui.error.maxlength', { length: contactLength.phoneNumber }),
    )
    .matches(constants.PHONE_NUMBER_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
  email: emailSchema.fields.email,
  ccEmail: emailSchema.fields.cc,
  addressee: string()
    .max(
      contactLength.addressee,
      i18n.t('ui.error.maxlength', { length: contactLength.addressee }),
    )
    .trim()
    .nullable(),
}).required();

export const contactSchema = object({
  postalCode: string()
    .max(
      contactLength.postalCode,
      i18n.t('ui.error.maxlength', { length: contactLength.postalCode }),
    )
    .matches(constants.ZIP_CODE_PATTERN, i18n.t('ui.error.format'))
    .trim()
    .required(i18n.t('ui.error.required.input')),
  address: string()
    .max(
      contactLength.address,
      i18n.t('ui.error.maxlength', { length: contactLength.address }),
    )
    .trim()
    .required(i18n.t('ui.error.required.input')),
  ...contactBaseSchema.fields,
}).required();

export const billingContactSchema = contactBaseSchema;
